import { Label } from "@radix-ui/react-label";
import { InputText } from "primereact/inputtext";
import React from "react";
import { SectionTitle } from "../EmployeeForm";

function EmergencyContact({ formData, handleOnChange }) {
  return (
    <section className="flex flex-col gap-3">
      <SectionTitle>Emergency Contact</SectionTitle>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 w-full">
        <div className="flex flex-col gap-1">
          <Label className="px-3">
            Contact Name <span className="text-red-600">*</span>
          </Label>
          <InputText
            value={formData.emergencyContactName}
            onChange={(e) =>
              handleOnChange("emergencyContactName", e.target.value)
            }
            placeholder="Contact Name *"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">
            Contact Number <span className="text-red-600">*</span>
          </Label>
          <InputText
            value={formData.emergencyContactNumber}
            onChange={(e) =>
              handleOnChange("emergencyContactNumber", e.target.value)
            }
            placeholder="Contact Number *"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">Email</Label>
          <InputText
            type="email"
            value={formData.emergencyContactEmail}
            onChange={(e) =>
              handleOnChange("emergencyContactEmail", e.target.value)
            }
            placeholder="Contact Email"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">
            Contact Address <span className="text-red-600">*</span>
          </Label>
          <InputText
            value={formData.emergencyContactAddress}
            onChange={(e) =>
              handleOnChange("emergencyContactAddress", e.target.value)
            }
            placeholder="Contact Address *"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
        <div className="flex flex-col gap-1">
          <Label className="px-3">
            Relation <span className="text-red-600">*</span>
          </Label>
          <InputText
            value={formData.relation}
            onChange={(e) => handleOnChange("relation", e.target.value)}
            placeholder="Relation *"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
        </div>
      </div>
    </section>
  );
}

export default EmergencyContact;
